import { createProductIdentifiersProto } from 'helpers/analytics';
import { EXCHANGE_INITIATE_PAGE } from 'constants/amethystPageTypes';
import { RETURN_LABEL_TYPE } from 'constants/amethystEnums';

export const evExchangeCheckedItemsClick = () => ({
  exchangeCheckedItemsClick: {}
});

export const evSelectItemsToExchangeClick = ({ orderId, lineItem, selected, deselected }) => ({
  selectItemsToExchangeClick: {
    clickedProduct: createProductIdentifiersWithSupplementalData(orderId, [lineItem])[0],
    selected,
    deselected
  }
});

export const evSelectReturnLabelType = ({ returnLabel }) => ({
  selectReturnLabelType: {
    sourcePage: EXCHANGE_INITIATE_PAGE,
    returnLabelType: determineReturnLabelType(returnLabel)
  }
});

export const evSubmitExchangeClick = () => ({
  submitExchangeClick: {}
});

export const pvExchangeConfirmation = ({ postExchangeInfo, returnedItem, exchangeItem, recommendationImpression, returnLabel }) => ({
  exchangeConfirmationPageView: {
    recommendationImpression: recommendationImpression,
    exchangeDetails: [createExchangeDetails(postExchangeInfo, returnedItem, exchangeItem)],
    returnLabelType: determineReturnLabelType(returnLabel)
  }
});

export const pvExchangeFlow = ({ orderId, lineItems }) => ({
  exchangeFlowPageView: {
    originalItemsForReturn: createProductIdentifiersWithSupplementalData(orderId, lineItems)
  }
});

export const pvSelectItemsToExchange = ({ order }) => {
  const { lineItems, orderId } = order;
  const nonExchangeableLineItems = lineItems.filter(lineItem => !lineItem.exchangeable);

  return {
    selectItemsToExchangePageView: {
      exchangeNotAvailable: createProductIdentifiersWithSupplementalData(orderId, nonExchangeableLineItems)
    }
  };
};

function createExchangeDetails(postExchangeInfo, originalItem, exchangeItem) {
  const { refundTotal, orderId, rmaId } = postExchangeInfo;
  return {
    refundTotal: refundTotal,
    evenExchange: true,
    originalOrderId: orderId,
    returnConfirmationNumber: rmaId,
    originalItems: createProductIdentifiersWithSupplementalData(orderId, [originalItem]),
    exchangeItems: createProductIdentifiersProto([exchangeItem])
  };
}

function createProductIdentifiersWithSupplementalData(orderId, lineItems) {
  return lineItems.map(lineItem => {
    const { product } = lineItem;
    const { asin, productId, styleId, stockId, colorId } = product;
    return {
      asin,
      productId,
      styleId,
      stockId,
      colorId,
      supplementalData: {
        amazonOrderId: orderId
      }
    };
  });
}

const determineReturnLabelType = type => RETURN_LABEL_TYPE[type] || 'UNKNOWN_RETURN_LABEL_TYPE';
